import {createRouter, createWebHistory} from 'vue-router'
import PageHome from '../views/PageHome.vue'
import ProductList from '../views/product/productList.vue'
import ProductDetails from '@/views/product/productDetails.vue'
import MembershipDetail from '@/views/membership/MembershipDetail.vue'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'home',
            component: PageHome
        },
        {
            path: '/membership-list',
            name: 'MembershipList',
            component: () => import('@/views/membership/MembershipList.vue')
        },
        {
            path: '/join-process',
            name: 'JoinProcess',
            component: () => import('@/views/join/JoinProcess.vue')
        },
        {
            path: '/firm-list',
            name: 'FirmList',
            component: () => import('@/views/firm/FirmList.vue')
        },
        {
            path: '/firm-detail/:firmId',
            name: 'firmDetail',
            component: ()=> import('@/views/firm/FirmDetail.vue'),
            props: true,
        },
        {
            path: '/product-list',
            name: 'ProductList',
            component: ProductList,
        },
        {
            path: '/productDetails/:id',
            name: 'ProductDetails',
            component: ProductDetails,
            props: true,
        },
        {
            path: '/article/:articleId',
            name: 'ArticleView',
            component: () => import('@/views/ArticleContent.vue')
        },
        {
            path: '/activityDetail/:activityId',
            name: 'activityDetail',
            component: () => import('@/views/activity/ActivityDetail.vue'),
        },
        {
            // 报名入口
            path: '/activitySignup/:activityId',
            name: 'ActivitySignUp',
            component: () => import('@/views/activity/ActivitySignUp.vue'),
        },
        {
            // 签到入口
            path: '/activityCheckin/:activityId',
            name: 'ActivityCheckIn',
            component: () => import('@/views/activity/ActivityCheckIn.vue'),
        },
        {
            path: '/association-activity',
            name: 'AssociationActivity',
            component: () => import('@/views/activity/AssociationActivity.vue'),
        },
        {
            // 活动海报移动端独立页面（扫码后进入）
            path: '/activityPosterMobile/:activityId',
            name: 'ActivityPosterMobile',
            component: () => import('@/views/activity/ActivityPosterMobile.vue'),
        },
        {
            path: '/news-list',
            name: 'NewsList',
            component: () => import('@/views/news/newsList.vue')
        },

        {
            path: '/ysca',
            children: [
                {
                    path: 'expertCommittee',
                    name: 'ExpertCommittee',
                    component: () => import('@/views/ysca/ExpertCommitee.vue')
                },
                {
                    path: 'coldChain',
                    name: 'ColdChain',
                    component: () => import('@/views/ysca/ColdChain.vue')
                },
                {
                    path: 'warehouseDistribution',
                    name: 'WarehouseDistribution',
                    component: () => import('@/views/ysca/WarehouseDistribution.vue')
                },
                {
                    path: 'businessCommittee',
                    name: 'BusinessCommittee',
                    component: () => import('@/views/ysca/BusinessCommittee.vue')
                },
                {
                    path: 'crossBorder',
                    name: 'CrossBorder',
                    component: () => import('@/views/ysca/CrossBorder.vue')
                },
                {
                    //党支部
                    path: 'PartyBranch',
                    name: 'PartyBranch',
                    component: () => import('@/views/ysca/PartyBranch.vue')
                },
                {
                    //办事处
                    path: 'HandleAffairs',
                    name: 'HandleAffairs',
                    component: () => import('@/views/ysca/HandleAffairs.vue')
                },
                {
                    //专委会
                    path: 'SpecialCommittee',
                    name: 'SpecialCommittee',
                    component: () => import('@/views/ysca/SpecialCommittee.vue')
                }
            ]
        },
        {
            path: '/RelatedFunctions',
            children: [
                {
                    path: 'fileNotice',
                    name: 'FileNotice',
                    component: () => import('@/views/RelatedFunctions/FileNotice.vue')
                },
                {
                    path: 'RelatedFileList/:fileType',
                    name: 'RelatedFileList',
                    component: () => import('@/views/RelatedFunctions/RelatedFileList.vue'),
                    props: true
                }
            ]
        },
        {
            path: '/membership/detail/:id',
            name: 'MembershipDetail',
            component: MembershipDetail
        }
    ]
})

// 路由守卫，用于设置页面标题
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

export default router
